(() => {
  const mount = () => {
    const root = document.querySelector('#kura-lp-root');
    const lineUrl = root?.dataset.lineUrl || 'https://lin.ee/qWS0axw';
    const source = document.querySelector('#km-content');
    if (!root || !source || root.querySelector('#mill-set')) return;
    const fragment = source.content.cloneNode(true);
    const teaser = fragment.querySelector('.km-teaser');
    const detail = fragment.querySelector('.km-detail');
    const repeat = fragment.querySelector('.km-repeat');
    const pair = (size = '5kg') => {
      const images = detail.querySelectorAll('.km-products img');
      const container = document.createElement('div');
      container.className = 'km-set-visual';
      const kura = images[1].cloneNode(true);
      const mill = images[0].cloneNode(true);
      const slug = size === '7.5kg' ? '7-5kg' : size;
      kura.src = kura.src.replace('5kg-white', slug + '-white');
      kura.alt = '空蔵 ' + size + ' ホワイト';
      kura.loading = mill.loading = 'eager';
      for (const [img, label] of [[kura, '空蔵 ' + size + '（真空保存容器）'], [mill, '匠味米（精米機）']]) {
        const figure = document.createElement('figure');
        figure.append(img);
        const caption = document.createElement('figcaption');
        caption.textContent = label;
        figure.append(caption);
        if (container.children.length) {
          const plus = document.createElement('span');
          plus.className = 'km-set-plus';
          plus.textContent = '＋';
          container.append(plus);
        }
        container.append(figure);
      }
      return container;
    };
    teaser.querySelector('h2').innerHTML = '空蔵と精米機を、<br>ひとつのセットに。';
    teaser.querySelector('.km-lead')?.remove();
    const hook = teaser.querySelector('.km-price-hook');
    hook.innerHTML = '<span class="km-status">5kgセット・キャンペーン価格</span><p class="km-total-label">空蔵5kg ＋ 匠味米</p><p class="km-hero-total">セットで <strong>27,450<small>円（税込）</small></strong></p><span class="km-off-badge">25%OFF</span><p class="km-addition">空蔵5kg単品に、<b>あと10,620円</b>で精米機も。</p><p class="km-note">15%OFFの単品価格16,830円との比較。</p>';
    teaser.querySelector('.km-button b').textContent = 'セットの容量・価格を見る';
    teaser.querySelectorAll('.km-button-copy small').forEach(el => el.remove());
    teaser.querySelector('.km-secondary').href = root.querySelector('.cta-section') ? '#single-purchase' : '#purchase';
    detail.querySelectorAll('.km-price-card').forEach((card, index) => {
      card.querySelector('.km-price-size').after(pair(['5kg', '7.5kg', '10kg'][index]));
      const extra = card.querySelector('.km-price-extra');
      extra.innerHTML = extra.innerHTML.replace('空蔵単品に', '単品に、あと').replace('＋', '').replace(' で精米機も', 'で精米機も。');
    });
    // Establish trust before the first purchase choices.
    let introAnchor = root.querySelector('#top');
    const proofBlocks = [
      root.querySelector('#meister'),
      root.querySelector('img[src*="section-02-results"]')?.closest('section')
    ];
    proofBlocks.filter(Boolean).forEach(block => {
      introAnchor?.after(block);
      introAnchor = block;
    });
    introAnchor?.after(teaser);
    const retail = root.querySelector('.retail-banner');
    if (retail) teaser.after(retail);
    const feature = root.querySelector('#features');
    if (feature) feature.before(detail);
    else root.querySelector('.lp-stage')?.append(detail);
    // Keep one set-price area; omit the former repeated CTA before the FAQ.
    const lineOffer = () => {
      const box = document.createElement('div');
      box.className = 'km-line-offer';
      box.innerHTML = '<p><small>空蔵単品をご検討の方へ</small><br><strong>LINE登録で単品15%OFF・セット25%OFF</strong></p><a href="'+lineUrl+'" target="_blank" rel="noopener">LINEに登録する ↗</a><p class="km-line-exclusion">※表示価格はLINE限定クーポン適用後の価格です。</p>';
      return box;
    };
    const linePanel = root.querySelector('#line-register .line-panel');
    if (linePanel) {
      const heading = linePanel.querySelector('h2');
      const lead = linePanel.querySelector('.line-panel__lead');
      if (heading) heading.textContent = 'LINE登録で、単品15%OFF・セット25%OFF。';
      if (lead) lead.textContent = '11月4日まで、LINE限定の単品15%OFF・セット25%OFFクーポン配布中。※表示価格はLINE限定クーポン適用後の価格です。';
    }
    // Keep the original single-item trigger and its Shopify event listeners.
    root.querySelectorAll('.cta-section').forEach(section => {
      if (section.id !== 'purchase') { section.remove(); return; }
      const buy = section.querySelector('[data-purchase-open]');
      if (!buy) return;
      buy.removeAttribute('style');
      buy.removeAttribute('data-layer');
      buy.className = 'km-secondary km-single-buy';
      buy.textContent = '空蔵単品を購入する →';
      buy.setAttribute('aria-label', '空蔵単品の容量と色を選ぶ');
      section.removeAttribute('data-design');
      section.removeAttribute('style');
      section.className = 'km-block km-buy-choice';
      section.id = 'single-purchase';
      section.innerHTML = '<p class="km-eyebrow">空蔵だけをご希望の方へ</p><h2>空蔵単品で購入</h2><div class="km-single-summary"></div>';
      const singleImage = detail.querySelectorAll('.km-products img')[1].cloneNode(true);
      singleImage.loading = 'eager';
      section.querySelector('.km-single-summary').append(singleImage);
      section.querySelector('.km-single-summary').insertAdjacentHTML('beforeend','<p><b>空蔵 KURA</b><br>5kg・7.5kg・10kg<br>単品<strong>15%OFF</strong><small>5kg：16,830円（税込）<br>※15%OFF適用済み。精米機は含みません。</small></p>');
      section.append(buy);
      section.append(lineOffer());
      const hub = document.createElement('section');
      hub.id = 'purchase';
      hub.className = 'km-block km-purchase-hub';
      const offer = detail.querySelector('#mill-set-offer');
      offer.before(hub);
      hub.append(offer, section);
      root.querySelector('#line-register')?.remove();
      section.querySelector('.km-line-offer').id = 'line-register';
      offer.querySelector('.km-secondary').href = '#single-purchase';
      offer.querySelector('.km-line-link')?.remove();
    });
    const drawer = root.querySelector('#purchase-configurator .purchase-drawer__lead');
    if (drawer) drawer.after(lineOffer());
    const cPurchase = root.querySelector('#purchase.kb-purchase');
    if (cPurchase) cPurchase.querySelector('#kb-form')?.before(lineOffer());
    const sticky = root.querySelector('.sticky-cta, .kb-sticky') || document.querySelector('.sticky-cta, .kb-sticky');
    if (sticky?.classList.contains('sticky-cta--split')) {
      const oldLine = sticky.querySelector('.kura-split-cta--line');
      if (oldLine) {
        oldLine.href = '#mill-set-offer';
        oldLine.removeAttribute('target');
        oldLine.className = 'kura-split-cta km-fixed-set';
        oldLine.innerHTML = '<strong>精米機セット</strong><span>価格・容量を見る ↑</span>';
      }
      const buy = sticky.querySelector('[data-purchase-open]');
      if (buy) buy.innerHTML = '<strong>空蔵単品</strong><span>容量・色を選んで購入 ›</span>';
      sticky.setAttribute('aria-label','精米機セットと空蔵単品');
    } else if (sticky) {
      const link = document.createElement('a');
      link.className = 'km-sticky-link';
      link.href = '#mill-set-offer';
      link.textContent = '精米機セットの価格を見る ↑';
      sticky.append(link);
    }
    detail.querySelector('.km-products')?.remove();
    detail.querySelector('.km-steps')?.remove();
    detail.querySelector('.km-spec')?.remove();
    detail.querySelector('h2').innerHTML = '暮らしに合わせて、<br>セット・単品を選ぶ。';
    detail.querySelector('.km-lead').textContent = '精米から始めるなら匠味米セット。保存容器だけなら空蔵単品をお選びください。';
    // The new sections change the document height after the browser's first
    // fragment scroll. Restore deep links once the content has been mounted.
    const revealInitialTarget = () => {
      const id = location.hash.slice(1);
      if (!/^(purchase(?:-design-[12])?|single-purchase|set-intro|mill-set(?:-offer)?|km-price-(?:5|75|10))$/.test(id)) return;
      const target = document.getElementById(id) || (/^purchase-design-/.test(id) && document.getElementById('purchase'));
      if (target) requestAnimationFrame(() => target.scrollIntoView({block:'start',behavior:'instant'}));
    };
    revealInitialTarget();
    if (document.readyState !== 'complete') window.addEventListener('load', revealInitialTarget, {once:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true});
  else mount();
})();
